/**
 * A dedicated axios instance for third-party geo providers (Nominatim,
 * Open-Elevation) — deliberately NOT the shared `axiosInstance` from
 * `@/lib/api`, and NOT routed through `ApiClient` (see CONTRIBUTING.md →
 * "Exception: third-party geo providers"). The problem was never axios itself,
 * only the shared instance's config and the interceptors `ApiClient` installs
 * on it:
 *
 * 1. `axiosInstance` sets `withCredentials: true`. Both providers answer
 *    `Access-Control-Allow-Origin: *`, which the browser rejects outright in
 *    credentials mode — and we must never send session cookies to a third
 *    party. A fresh instance defaults to `withCredentials: false`.
 * 2. `axiosInstance` carries our API `baseURL` plus auth/locale/build-version
 *    interceptors that have no business on an external host. A fresh instance
 *    has none of them — interceptors are registered per-instance, not on the
 *    `axios` module globally.
 * 3. `ApiClient` installs `humps` interceptors on `axiosInstance` that would
 *    rewrite `display_name` to `displayName` before zod sees the payload, and
 *    decamelize outgoing params. A fresh instance never sees those either.
 *
 * One instance shared by both services — neither sets a `baseURL`, so there is
 * no per-host conflict in reusing it.
 */
import axios from 'axios';

export const geoAxios = axios.create({
  withCredentials: false,
});
